import { useEffect } from "react";
import { useBreadcrumbs } from "../../Hooks/useBreadcrumbs";

type Props = {
  breadCrumbKey: string;
  order: number;
  name: string;
  linkPath: string;
};

export const SetBreadcrumb = ({ breadCrumbKey, order, name, linkPath }: Props) => {
  const { removeBreadcrumb, setBreadcrumb } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumb({ key: breadCrumbKey, order, name, linkPath });

    return () => removeBreadcrumb(breadCrumbKey);
  }, [setBreadcrumb, removeBreadcrumb, breadCrumbKey, order, name, linkPath]);

  return null;
};
